var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("app-launcher-warning", {
    attrs: {
      "app-state": _vm.appState,
      "app-error": _vm.appError,
      "v-suggest": _vm.vSuggest,
      "v-target": _vm.updateTargetVersion,
      "is-updating": _vm.isPreparingInstall,
      "is-loading": _vm.isSavingSettings,
      "is-user-an-admin": _vm.isUserAdmin,
    },
    on: {
      "app-install": _vm.onUpdateToMaxAppVersion,
      "app-update": _vm.onUpdateToMaxAppVersion,
      "accept-version": _vm.onAcceptVersion,
      "retry-update": _vm.onRetryAppUpdate,
      update: _vm.onUpdateToTargetAppVersion,
      cancel: _vm.onClearChanges,
      "go-to-launcher": _vm.onGoToAppLauncher,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }